const state = {
    show: false,
    loginUrl: null,
    logoutUrl: null,
};

const getters = {}

const actions = {
    start({ commit }) {
        commit('setState', true)
    },
    finish({ commit }) {
        commit('setState', false)
    }

};

const mutations = {
    setState(state, show) {
        state.show = show
    },
    refreshCurrentUrl(state, fullPath) {
        state.currentUrl = window.location.protocol + '//' + window.location.host + fullPath
        state.loginUrl = window.envConfig.AUTH_BASEURL + '/customer?goto=' + state.currentUrl
        state.logoutUrl = window.envConfig.AUTH_BASEURL + '/logout?goto=' + state.currentUrl
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}